import React from "react";
import {
  TextField,
  Chip,
  Box,
  Paper,
  InputAdornment,
  IconButton,
} from "@mui/material";
import AddIcon from "@material-ui/icons/Add";

const MultiItemsInput = ({
  handleAddItem,
  handleDeleteItem,
  itemsList,
  currentItem,
  handleCurrenItemChange,
  placeholder,
}) => {
  const handleKeyPress = (event) => {
    if (event.key === "Enter" || event.key === ",") {
      event.preventDefault();
      handleAddItem();
    }
  };

  return (
    <Box sx={{ width: "100%", margin: "0 auto" }}>
      <TextField
        fullWidth
        value={currentItem}
        onChange={(e) => handleCurrenItemChange(e)}
        onKeyPress={handleKeyPress}
        placeholder={placeholder}
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <IconButton onClick={handleAddItem} edge="end">
                <AddIcon />
              </IconButton>
            </InputAdornment>
          ),
        }}
      />
      <Paper
        elevation={0}
        sx={{
          display: "flex",
          flexWrap: "wrap",
          listStyle: "none",
          p: 0.5,
          m: 0,
          mb: 1,
        }}
      >
        {itemsList?.map((itemList, index) => (
          <Chip
            key={index}
            color="secondary"
            label={itemList}
            onDelete={() => handleDeleteItem(itemList)}
            sx={{ m: 0.5 }}
          />
        ))}
      </Paper>
    </Box>
  );
};

export default MultiItemsInput;
